module.exports = __webpack_public_path__ + "static/media/disconnected.8ff8ac68.svg";